import React from 'react'
import { Container, Nav, Tab } from 'react-bootstrap'
import Classification from './Classification'
import Vas from './Vas'
import '../../styles/tabs.css'

export default function WmProcessing() { 
    return (
        <Container fluid>
            <Tab.Container id='submenu-header' defaultActiveKey='classification'>
                <Nav variant='pills' className='mt-3 mb-2 justify-content-center border-bottom border-1 spread-font '>
                    <Nav.Item  bsPrefix='subheader-item'>
                        <Nav.Link as='button' bsPrefix='subheader-link' eventKey='classification'><p>Clasificación</p></Nav.Link>
                    </Nav.Item>
                    <Nav.Item bsPrefix='subheader-item'>
                        <Nav.Link as='button' bsPrefix='subheader-link' eventKey='vas'><p>VAS</p></Nav.Link>
                    </Nav.Item>
                </Nav>
                <Tab.Content className='gx-0 px-0 mx-0'>
                    <Tab.Pane eventKey='classification'>
                        <Classification />  
                    </Tab.Pane>
                    <Tab.Pane eventKey='vas' >
                        <Vas />
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        </Container>
    )    
}
